import React from 'react';
import {render} from 'react-dom';
import { Provider } from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import registerServiceWorker from './components/common/registerServiceWorker';
import store from './store/'
// CSS
import 'normalize.css';
import './index.css';

import router from './router';

render(
	<MuiThemeProvider>
    	<Provider store={store}>{router}</Provider>
    </MuiThemeProvider>,
    document.getElementById('root')
)

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js